import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { ExpandedTooltip, Icon, InputWithIcon,
// SelectMenu,
toast, BackdropLoader } from '@livable/saas-react-components';
import { Button, FormHelperText, FormControl, Grid, InputLabel, IconButton, InputAdornment, OutlinedInput, TextField, Typography
// MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { DetailedStreetFinder } from 'src/components/general/DetailedStreetFinder';
import useStyles from './styles';
import { useFormik } from 'formik';
import { translate } from 'src/utils/translator';
import { PropertyDetailsSchema } from 'src/utils/formValidation/PropertyDetails';
// import InputMask from 'react-input-mask';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { isValueNumber } from 'src/utils/typeValidators';
export const ModalContent = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2, _store$homeDashboardS3, _store$homeDashboardS5;
  let handleClose = _ref.handleClose,
    triggerRefresh = _ref.triggerRefresh;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();

  // const [propertyType, setPropertyType] = useState(10);
  // const handlePropertyTypeChange = event => {
  //   if (event.target.value) setPropertyType(event.target.value);
  // };

  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    handleStartValidate = _useState2[0],
    setHandleStartValidate = _useState2[1];
  const formik = useFormik({
    initialValues: {
      address: (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.propertyInformation) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.propertyAddress,
      ownership: (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.propertyInformation) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.ownership,
      buildingSquare: (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.propertyBuildingSquare
    },
    // PropertyDetailsInitVales,
    validationSchema: PropertyDetailsSchema,
    enableReinitialize: true,
    onSubmit: () => {
      setHandleStartValidate(true);
    }
  });
  const handleStartSubmitting = async resultId => {
    var _store$homeDashboardS4;
    const dataToSave = {
      propertyId: store.homeDashboardStore.selectedPropertyId,
      propertyAddress: formik.values.address,
      ownership: formik.values.ownership,
      // website: '',
      buildings: [{
        buildingId: (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.propertyBuildingId,
        buildingAddress: formik.values.propertyAddress,
        buildingSquare: isValueNumber(formik.values.buildingSquare) && Number(formik.values.buildingSquare) > 0 ? Number(formik.values.buildingSquare) : null,
        rentControl: true
      }]
    };
    if (resultId) {
      dataToSave.addressId = resultId;
      dataToSave.buildings[0].buildingAddressId = resultId;
    }
    store.properties.updatePropertyAsync.run(dataToSave, [store.homeDashboardStore.selectedPropertyId]).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        toast('success', {
          body: ['Property Information successfully updated!']
        });

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        triggerRefresh && triggerRefresh();
        handleClose();
      }
    });
  };
  const isLoading = () => {
    var _store$properties$upd;
    return ((_store$properties$upd = store.properties.updatePropertyAsync) === null || _store$properties$upd === void 0 || (_store$properties$upd = _store$properties$upd.inProgressUnicIds) === null || _store$properties$upd === void 0 ? void 0 : _store$properties$upd.includes(store.homeDashboardStore.selectedPropertyId)) || store.address.updateAddressAsync.inProgress || store.address.addNewAddressAsync.inProgress;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formList
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formItem
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Property details"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    name: "address"
    // defaultPropertyAddress={defaultPropertyAddress}
    // defaultPropertyAddress={defaultPropertyAddressExt}
    ,
    defaultPropertyAddress: (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.propertyAddressSeparated
    // defaultPropertyAddress={store.homeDashboardStore.getCurrentProperty?.propertyInformation?.address}
    ,
    validator: formik,
    error: !!formik.errors.address,
    helperText: translate(formik.errors.address, t)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.formItem
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    onBlur: formik.handleBlur,
    onChange: e => {
      formik.handleChange(e);
      if (!formik.touched.ownership && e.target.value.trim().length > 1) {
        setTimeout(() => {
          formik.setFieldTouched('ownership', true);
        }, 0);
      }
    },
    error: formik.touched.ownership && Boolean(formik.errors.ownership)
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "user-location"
    })
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, t('add_new_property_flow.ownership_entity')), /*#__PURE__*/React.createElement(OutlinedInput, {
    fullWidth: true,
    type: "text",
    id: "ownership",
    name: "ownership",
    label: t('add_new_property_flow.ownership_entity'),
    value: formik.values.ownership,
    disabled: store.company.companyFeatureStore.readOnlyPropertyPropertyInfo || store.properties.createNewPropertyAsync.inProgress || store.properties.updatePropertyAsync.inProgress,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      type: "infoTooltip"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: t('add_new_property_flow.ownership_entity_hint'),
      type: "grey"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "question"
    }))))
  }), formik.touched.ownership && !!formik.errors.ownership && /*#__PURE__*/React.createElement(FormHelperText, null, translate(formik.errors.ownership, t)))))), /*#__PURE__*/React.createElement("div", {
    className: classes.formItem
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Property square footage"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Square footage is required for utility corresponding allocation methods. It is also required to properly set Common Area Deduction (CAD), which values will rely on the property square footage."), /*#__PURE__*/React.createElement("div", {
    className: classes.squareFtWrapper
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "buildingSquare",
    name: "buildingSquare",
    label: t('general.square_ft'),
    variant: "outlined",
    fullWidth: true,
    type: "text",
    value: formik.values.buildingSquare,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onBlur: formik.handleBlur,
    onChange: event => {
      if (!/^[1-9][0-9]*$|^$/.test(event.target.value)) return;
      formik.handleChange(event);
    },
    error: formik.touched.buildingSquare && Boolean(formik.errors.buildingSquare),
    helperText: formik.touched.buildingSquare && formik.errors.buildingSquare
  }))))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => {
      handleClose();
    },
    'custom-attribute': '680-new-billing-module'
  }, t('Cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit"
    // type="button"
    ,
    variant: "contained",
    disabled: isLoading(),
    onClick: formik.handleSubmit,
    'custom-attribute': '681-new-billing-module'
  }, t('Save information')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading()
  }));
});